/**
 * @file GTag constant
 * @module constant.gtag
 * @author Surmon <https://github.com/surmon-china>
 */

export enum GAEventCategories {
  Comment = 'comment',
  Share = 'share',
  Widget = 'widget',
  Universal = 'global',
  Article = 'page_article',
  Index = 'page_index',
  App = 'page_app',
  About = 'page_about',
  Lens = 'page_lens'
}
